// extracted by mini-css-extract-plugin
export var container = "_dq-0";
export var popoverContent = "_dq-1";
export var tosLink = "_dq-2";